import React from 'react'
import Skeleton from 'react-loading-skeleton'
import useStyles from '../styles'

const ReportSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.graphsContainer}>
      <Skeleton height={300} />
      <Skeleton height={300} />
      <Skeleton height={300} />
      <Skeleton height={300} />
    </div>
  )
}

export default ReportSkeleton
